"use client";

import React, { useEffect, useState, Suspense, lazy } from "react";
import { Card, Box, Typography } from "@mui/material";

const Chart = lazy(() => import("react-apexcharts"));

const CustomerIntentChart = ({ data = [] }) => {
  const [isChartLoaded, setChartLoaded] = useState(false);

  useEffect(() => {
    setChartLoaded(true);
  }, []);

  // Extract labels and percentages from data
  const labels = data.map(item => item.intent || 'Unknown');
  const series = data.map(item => parseFloat(item.percentage) || 0);

  // Color palette for intents
  const colors = ['#605DFF', '#FF6B6B', '#4ECDC4', '#FFD166', '#95E1D3', '#F38181'];

  const options = {
    chart: { type: 'donut' },
    labels: labels.length > 0 ? labels : ['No Data'],
    colors: colors.slice(0, labels.length),
    legend: {
      position: 'bottom',
      labels: { colors: '#64748B' }
    },
    dataLabels: { enabled: true },
    plotOptions: {
      pie: {
        donut: {
          size: '65%'
        }
      }
    }
  };

  return (
    <Card sx={{ boxShadow: "none", borderRadius: "7px", p: 3, height: "100%" }}>
      <Typography variant="h6" fontWeight={700} mb={2} className="text-black">
        Top Customer Intents
      </Typography>
      <Box sx={{ height: 300 }}>
        {isChartLoaded && (
          <Suspense fallback={<div>Loading...</div>}>
            <Chart options={options} series={series} type="donut" height={300} />
          </Suspense>
        )}
      </Box>
    </Card>
  );
};

export default CustomerIntentChart;